import type { MessageDescriptor } from "react-intl";
import type { ContractTypeValue, CurrencyTypeValue, SalaryTypeValue } from "types/salaryRange";

export const ContractTypeMessageIds: Record<ContractTypeValue, MessageDescriptor> = {
    employment: { id: "salary-range.contract-type.employment" },
    b2b: { id: "salary-range.contract-type.b2b" },
    specificWork: { id: "salary-range.contract-type.specific-work" },
    mandate: { id: "salary-range.contract-type.mandate" },
    substitute: { id: "salary-range.contract-type.replacement" },
    agency: { id: "salary-range.contract-type.agency" },
    temporary: { id: "salary-range.contract-type.temporary-employment" },
    internship: { id: "salary-range.contract-type.internship" },
};

export const SalaryTypeMessageIds: Record<SalaryTypeValue, MessageDescriptor> = {
    gross: { id: "salary-range.salary-type.gross" },
    net: { id: "salary-range.salary-type.net" },
};

export const CurrencyMessageIds: Record<CurrencyTypeValue, MessageDescriptor> = {
    PLN: { id: "pln" },
    USD: { id: "usd" },
    EUR: { id: "eur" },
    UAH: { id: "uah" },
};
